import styled from 'styled-components';

export const BetaBadge = styled.span`
    padding: 5px 15px;
    background: linear-gradient(45deg, #80a4ff 0%, #4838ff 100%);
    color: white;
    width: 70px;
    font-weight: bold;
    font-size: 14px;
    border-radius: 30px;
    margin-left: 10px;
`;

export default BetaBadge;
